import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { AppSharedModule } from "../../shared/app-shared.module";
import { AccordionModule } from "primeng/accordion";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ChartModule } from "primeng/chart";
import { OrderListModule } from "primeng/orderlist";
import { TableModule } from "primeng/table";
import { DropdownModule } from "primeng/dropdown";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { RouterModule } from "@angular/router";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";

import { DashboardMultiStationComponent } from "./components/dashboard-multistation.component";
import { DashboardMultiStationService } from "./dashboard-multistation.service";
import { MsTodaysSnapshotComponent } from "./ms-todays-snapshot/ms-todays-snapshot.component";
import { MsBlockedListAttemptsComponent } from "./ms-blocked-list-attempts/ms-blocked-list-attempts.component";
import { MsBlockedAttemptTableComponent } from "./ms-blocked-list-attempts/ms-blocked-attempt-table/ms-blocked-attempt-table.component";
import { MsStationStatusComponent } from "./ms-station-status/ms-station-status.component";
import { MsVisitorGraphComponent } from "./ms-visitor-graph/ms-visitor-graph.component";
import { MsTodaysVisiteesComponent } from "./ms-todays-visitees/ms-todays-visitees.component";
import { MsWaitingForVerificationComponent } from "./ms-waiting-for-verification/ms-waiting-for-verification.component";
import { MsTodaysReasonsComponent } from "./ms-todays-reasons/ms-todays-reasons.component";

@NgModule({
	declarations: [
		DashboardMultiStationComponent,
		MsTodaysSnapshotComponent,
		MsBlockedListAttemptsComponent,
		MsBlockedAttemptTableComponent,
		MsStationStatusComponent,
		MsVisitorGraphComponent,
		MsTodaysVisiteesComponent,
		MsWaitingForVerificationComponent,
		MsTodaysReasonsComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		AppSharedModule,
		AccordionModule,
		ScrollPanelModule,
		ChartModule,
		OrderListModule,
		TableModule,
		DropdownModule,
		SchoolselectorModule,
		ProgressSpinnerModule,
		RouterModule,
	],
	providers: [DashboardMultiStationService],
})
export class DashboardMultiStationModule {}
